<mat-card class="mat-elevation-z8">
  <div class="row">
    <div class="col"></div>
    <div class="col-1">
      <!--<button mat-raised-button color="primary" (click)="hideTable()">Back</button>-->
    </div>

  </div>
  <form [formGroup]="product_unit_register_form">
    <div class="form-group">
      <label>Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
      <input type="text" class="form-control code_box" formControlName='name'>
    </div>
    <div class="form-group">
      <label>Display Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
      <input type="text" class="form-control code_box" formControlName='display_name'>
    </div>
    <button mat-raised-button color="primary" (click)="registerProductUnit()" style="text-transform: capitalize"
            [disabled]="!product_unit_register_form.valid">{{action}}</button>
  </form>
</mat-card>

